import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getWithAuth, putWithAuth } from "../../../api/api";
import { API_URLS } from "../../../api/apiConfig";

const ModalChangeUserRole = ({ onClose, user }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [roles, setRoles] = useState([]);

  // role actual puede venir como user.role.id o user.role_id
  const initialRoleId = user?.role?.id || user?.role_id || "";
  const [selectedRoleId, setSelectedRoleId] = useState(initialRoleId);

  const fetchRoles = async () => {
    try {
      setIsLoading(true);
      const resp = await getWithAuth(API_URLS.GET_ROLES);
      if (resp.message === "success") {
        setRoles(resp.data || []);
      } else {
        setShowAlert(true);
        setAlertMessage(resp.detail || "No se pudieron obtener los roles.");
      }
    } catch (e) {
      console.error("Error fetching roles:", e);
      setShowAlert(true);
      setAlertMessage("Error al cargar los roles.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const onSave = async () => {
    if (!selectedRoleId) {
      setShowAlert(true);
      setAlertMessage("Selecciona un rol.");
      return;
    }
    try {
      setIsSaving(true);
      const resp = await putWithAuth(
        API_URLS.ASSIGN_ROLE_TO_USER(user.id, selectedRoleId)
      );
      if (resp.message === "success") {
        // Si prefieres no recargar, puedes levantar un callback para refrescar la lista padre
        window.location.reload();
      } else {
        setShowAlert(true);
        setAlertMessage(resp.detail || "No se pudo actualizar el rol.");
      }
    } catch (e) {
      console.error("Error saving role:", e);
      setShowAlert(true);
      setAlertMessage("Error al guardar el rol.");
    } finally {
      setIsSaving(false);
    }
  };

  const selectedRole = roles.find((r) => r.id === selectedRoleId);

  return (
    <Modal show onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Cambiar rol de usuario</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isLoading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "10vh" }}
          >
            <div
              className="spinner-grow text-color-verde-wofyrooms"
              style={{ width: "5rem", height: "5em" }}
              role="status"
            />
          </div>
        ) : (
          <>
            {showAlert && (
              <div className="alert alert-danger">{alertMessage}</div>
            )}

            <div className="mb-4">
              <label className="form-label fw-semibold">Usuario</label>
              <div>
                {user?.name} {user?.last_name} —{" "}
                <span className="text-muted">{user?.email}</span>
              </div>
            </div>

            <div className="mb-4">
              <label htmlFor="role-select" className="form-label fw-semibold">
                Rol
              </label>
              <select
                id="role-select"
                className="form-select"
                value={selectedRoleId}
                onChange={(e) => setSelectedRoleId(e.target.value)}
              >
                <option value="">Selecciona un rol…</option>
                {roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name}{" "}
                    {role.description ? `— ${role.description}` : ""}
                  </option>
                ))}
              </select>
              {initialRoleId && (
                <small className="text-muted d-block mt-2">
                  Rol actual:{" "}
                  <b>
                    {user?.role?.name ||
                      roles.find((r) => r.id === initialRoleId)?.name ||
                      "N/D"}
                  </b>
                </small>
              )}
            </div>

            {selectedRole?.description && (
              <div className="alert alert-secondary">
                <div className="fw-semibold mb-1">
                  Descripción del rol seleccionado
                </div>
                <div className="text-muted">{selectedRole.description}</div>
              </div>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onClose}
          disabled={isSaving}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSave}
          disabled={
            isSaving ||
            isLoading ||
            selectedRoleId === initialRoleId ||
            !selectedRoleId
          }
        >
          {isSaving ? "Guardando…" : "Guardar cambios"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalChangeUserRole;
